export const getPageForAdvertisement = async () => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/banner_schedules/page`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responseData = await response.json()
    return responseData
  } catch (error) {
    console.log('Error', error)
  }
}

export const getAdPosition = async (pageId: number) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/banner_schedules/ad_position?page_id=${pageId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responseData = await response.json()
    return responseData
  } catch (error) {
    console.log('Error', error)
  }
}

export const sendAdvertiseRequest = async (data: FormData) => {
  try {
    const response = await fetch(`${process.env.API_URL}/banner_schedules`, {
      method: 'POST',
      credentials: 'include',
      body: data,
    })

    const responseData = await response.json()
    return responseData
  } catch (error) {
    console.log('Error', error)
    return { status: 'error' }
  }
}
